module.exports = __webpack_public_path__ + "static/media/9DESA3.596cd46f.jpg";